/* global document */

import $ from "jquery";
import jQuery from "jquery";
import ready from '../utils/documentReady.js';
import '../utils/jquery.validate.min';

ready(function () {

	jQuery.validator.addMethod("checkName", function (value, element) {
		let pattern = new RegExp(/^([-а-яёА-ЯЁ\s]*?)$/);
		return pattern.test(value);
	});

	jQuery.validator.addMethod("checkEmail", function (value, element) {
		let pattern = new RegExp(/^(?!.*[а-яА-ЯёЁ])^(?![._-])[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}(?![._-]$)$/);
		return pattern.test(value);
	});

	// jQuery.validator.addMethod('password', function (value) {
	// 	let valid = false;
	// 	if (value.match('[A-Z]+') && value.match('[a-z]+') && value.match('[0-9]+') && value.match('[\\][,.<>/?;:\'"{}|`~\!@#$%^&*()_+=\\\\-]+')) {
	// 		valid = true;
	// 	}
	// 	return valid;
	// }, '');

	jQuery.validator.addMethod("requireFromGroup", function (value, element, options) {
		let numberRequired = options[0];
		let selector = options[1];
		let fields = $(selector, element.form);
		let filled_fields = fields.filter(function () {
			return $(this).val() !== "";
		});
		let empty_fields = fields.not(filled_fields);
		return !(filled_fields.length < numberRequired && empty_fields[0] === element);
	}, '');

	$('form[data-check-form]').each(function (index, element) {
		let $this = $(this);
		$this.validate({
			errorClass: "error",
			validClass: "success",
			errorElement: "em",
			focusInvalid: true,
			invalidHandler: function (event, validator) {
				let errors = validator.numberOfInvalids();
				if (errors) {
					$this.addClass('error')
				} else {
					$this.removeClass('error')
				}
			},
			submitHandler: function (form) {
				$("em.error").hide();
				$this.removeClass('error')
				// form.submit();
			},
			highlight: function (element, errorClass, validClass) {
				$(element).addClass(errorClass).removeClass(validClass);
				if ($(element).hasClass('field-select__select')) {
					$(element).parent().addClass(errorClass).removeClass(validClass);
				}
			},
			unhighlight: function (element, errorClass, validClass) {
				$(element).removeClass(errorClass).addClass(validClass);
				if ($(element).hasClass('field-select__select')) {
					$(element).parent().removeClass(errorClass).addClass(validClass);
				}
			},
			errorPlacement: function (error, element) {
				if ($(element).parent().hasClass('base-checkbox') || $(element).parent().hasClass('base-radio')) {
					// error.insertBefore(element);
				} else if ($(element).parent().hasClass('base-select')) {
					error.insertAfter($(element).parent().find('.select2-container'));
				} else {
					error.insertAfter(element);
				}
			}
		});

		$this.find('input').on('input', () => {
			if ($this.valid()) {
				$this.addClass('valid')
				$this.removeClass('error')
			} else {
				$this.removeClass('valid')
			}
		})
	});

	if ($(document).find('form[data-check-form]')) {
		$('.js-required-file').each(function () {
			$(this).rules('add', {
				required: true,
				messages: {
					required: "Загрузите резюме"
				}
			});
		});

		$('input[required]').each(function () {
			$(this).rules('add', {
				required: true,
				messages: {
					required: "Обязательное поле"
				}
			});
		});

		$('input[type="password"]').each(function () {
			$(this).rules('add', {
				password: false,
			});
		});

		$('input[minlength]').each(function () {
			const minLength = $(this).attr('minlength');
			$(this).rules('add', {
				minlength: minLength,
				messages: {
					minlength: `Длина меньше ${minLength} символов`
				}
			});
		});

		$('textarea[required]').each(function () {
			$(this).rules('add', {
				required: true,
				messages: {
					required: "Обязательное поле"
				}
			});
		});

		$('select[required]').each(function () {
			$(this).rules('add', {
				required: true,
				messages: {
					required: "Обязательное поле"
				}
			});
		});

		$('input[type="email"]').each(function () {
			$(this).rules('add', {
				email: true,
				checkEmail: true,
				messages: {
					email: "Неверный формат",
					checkEmail: "Неверный формат",
				}
			});
		});

		$('.js-required-text').each(function () {
			$(this).rules('add', {
				checkName: true,
				messages: {
					checkName: "Недопустимые символы"
				}
			});
		});
	}
});
